import { logger } from "@sentry/browser";
import storage from "./storage";

enum Domain {
  App = "app",
  Cache = "cache",
  Diagnostic = "diagnostic",
  Form = "form",
  Network = "network",
  Storage = "storage",
  SW = "sw",
  Upload = "upload",
}

let sentryEnabled: any;
let gitRevision: any;
let user: any;

async function trace(domain: Domain, ...args: any[]) {
  console_log(domain, ...args);
}

async function debug(domain: Domain, ...args: any[]) {
  console_log(domain, ...args);
  if (await shouldSendToSentry()) {
    const options = await logOptions(domain);
    if (options) {
      logger.debug(message(domain, args), options);
    }
  }
}

async function info(domain: Domain, ...args: any[]) {
  console_log(domain, ...args);
  if (await shouldSendToSentry()) {
    const options = await logOptions(domain);
    if (options) {
      logger.info(message(domain, args), options);
    }
  }
}

async function warn(domain: Domain, ...args: any[]) {
  console_log(domain, ...args);
  if (await shouldSendToSentry()) {
    const options = await logOptions(domain);
    if (options) {
      logger.warn(message(domain, args), options);
    }
  }
}

async function error(domain: Domain, ...args: any[]) {
  console_log(domain, ...args);
  if (await shouldSendToSentry()) {
    const options = await logOptions(domain);
    if (options) {
      logger.error(message(domain, args), options);
    }
  }
}

async function fatal(domain: Domain, ...args: any[]) {
  console_log(domain, ...args);
  if (await shouldSendToSentry()) {
    const options = await logOptions(domain);
    if (options) {
      logger.fatal(message(domain, args), options);
    }
  }
}

async function shouldSendToSentry() {
  sentryEnabled ??= await storage.getItem("sentryEnabled", {
    storeName: "main",
  });

  return sentryEnabled?.value === true;
}

function message(domain: Domain, args: any[]): string {
  const message = args
    .map((a: any) => {
      const t = typeof a;
      if (t === "string" || t === "number" || t === "boolean" || t === "undefined") {
        return a;
      }
      return JSON.stringify(a);
    })
    .join(" ");

  return `[${domain}] ${message}`;
}

async function logOptions(domain: Domain) {
  gitRevision ??= await storage.getItem("git_revision", { storeName: "main" });
  user ??= await storage.getItem("user_id", { storeName: "main" });

  if (!user?.value) return null;

  return {
    gitRevision: gitRevision,
    userId: user.value,
    path: `${location.pathname}${location.search}`,
    domain: domain,
  };
}

function console_log(domain: Domain, ...args: any[]): undefined {
  console.log(`[${domain}]`, ...args);
}

export { Domain, trace, debug, info, warn, error, fatal };
